import React from 'react';
import StakingSectionsSections from '../../components/ptgc/staking/Index';  // ✅ Fix import

const StakingSectionsPage = () => {
  return (
    <>
      <StakingSectionsSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default StakingSectionsPage;